import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

// import modules
import * as app from './modules/app';
import * as bookTravel from './modules/bookTravel';
import * as clearState from './modules/clearState'
import * as co2Info from './modules/co2Info';
import * as flightsInfo from './modules/flightsInfo';
import * as meetings from './modules/meetings';
import * as pnr from './modules/pnr';
import * as travellersAndTrips from './modules/travellersAndTrips';
import * as travelPolicy from './modules/travelPolicy';
import * as userManagement from './modules/userManagement';


Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    app,
    bookTravel,
    clearState,
    co2Info,
    flightsInfo,
    meetings,
    pnr,
    travellersAndTrips,
    userManagement,
    travelPolicy
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  plugins: [
    createPersistedState(),
  ]
})
